import { h } from 'preact';

export default props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
		<path d="M12.5 15L7.5 10L12.5 5" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
	</svg>
);